import {openMenu} from "../../../components/Header/actions";
import {mdScreenStepsSizes} from "../../App/constants";

const navigation_1 = {
  selector: '#logout-button-tour-element',
  key: 'report_settings_navigation_logout',
  position: 'bottom',
};
const navigation_1_mobile = {
  ...navigation_1,
  selector: '#logout-button-tour-element-side-menu',
  dispatchFn: [openMenu]
};

export const getNavigationChapterSteps = (width) => {
  return mdScreenStepsSizes.includes(width) ? [
    navigation_1_mobile,
  ] : [
    navigation_1,
  ];
};